"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseJwt;
var isOnNode = typeof window === "undefined";
var atob;
if (isOnNode) {
  atob = function atob(input) {
    return Buffer.from(input, "base64").toString("binary");
  };
} else {
  atob = self.atob;
}
function parseJwt(token) {
  try {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (character) {
      return "%" + ("00" + character.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
}